import PlayerAvatar from '../ui/PlayerAvatar';
import { CSS_CLASSES } from '../../constants/uiConstants';

/**
 * Reusable player button component
 * Eliminates code duplication across components
 */
const PlayerButton = ({
  player,
  players = [],
  setSelectedPlayer,
  setActiveTab,
  className = '',
  showAvatar = true,
  avatarSize = 'sm',
  children,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(player);
      return;
    }

    // Default behavior: navigate to analytics
    const fullPlayer = players.find(p => p.id === player.id) || player;
    if (fullPlayer && setSelectedPlayer) {
      setSelectedPlayer(fullPlayer);
      if (setActiveTab) {
        setActiveTab('analytics');
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`${CSS_CLASSES.BUTTON_HOVER} ${className}`}
    >
      {showAvatar && (
        <PlayerAvatar
          initials={player.initials}
          size={avatarSize}
          className={avatarSize === 'sm' ? 'mr-2' : 'mr-3'}
        />
      )}
      {children || player.name}
    </button>
  );
};

export default PlayerButton;
